import React, { useContext, useState } from "react"
import { useStaticQuery, graphql, navigate } from "gatsby"
import { StockContext } from "context/stock-context"


import SEO from "components/seo"
import Layout from "components/layout"
import { GlobalCover } from "components/global/cover/cover"
import { InvestorHeadline } from "components/pages/investor/headline"
import { InverstorAnnualReports } from "components/pages/investor/annual-reports"
import { InvestorQuickAccess } from "components/pages/investor/quick-access"
import { YoutubeFrame } from "components/global/youtube-frame/youtube-frame"
import { GlobalMarketingGallery } from "components/global/marketing-gallery/marketing-gallery"
import { StockPerformance } from "components/global/stock-performance/stock-performance"


const Investor = ({ path, pageContext, location }) => {
  const data = useStaticQuery(GET_INVESTOR_DETAILS)
  const lang = pageContext.langKey
  const { stock } = useContext(StockContext)

  const annualfile = data.wordPress.fileCategory
  const pageData = lang === "en"
    ? data.wordPress.page.investorLandingPage
    : data.wordPress.page.translation.investorLandingPage
    || data.wordPress.page.investorLandingPage

  const { seo, backgroundColor } = lang === "en"
    ? data.wordPress.page
    : data.wordPress.page.translation
    || data.wordPress.page

  const SEODefaultImg = pageData.cover.image.sourceUrl

  const bgColor = backgroundColor?.backgroundColor?.color

  return (
    <Layout path={path} theme={bgColor} lang={lang}>
      <SEO
        title={seo.title}
        desc={seo.metaDesc}
        fbImg={SEODefaultImg}
        fbTitle={seo.opengraphTitle}
        fbDesc={seo.opengraphDescription}
        url={location.href}
        twitterTitle={seo.twitterTitle}
        twitterDesc={seo.twitterDescription}
        twitterImg={SEODefaultImg}
      />
      <GlobalCover data={pageData.cover} theme={bgColor} breadcrumb={path} />
      <InvestorHeadline data={pageData.headline} />
      <StockPerformance className="overflow-hidden bg-light" data={stock} lang={lang} />
      <InverstorAnnualReports data={annualfile} lang={lang} />
      <InvestorQuickAccess data={pageData.quickAccess} />
      <YoutubeFrame link={pageData.video} thumbnail={pageData.videoThumbnail} />
      <GlobalMarketingGallery data={pageData.investorRelations} />
    </Layout>
  )
}

export default Investor

const GET_INVESTOR_DETAILS = graphql`
query Investor {
    wordPress {
      page(id: "investor-landing", idType: URI) {
        backgroundColor {
          backgroundColor {
            color
          }
        }
        seo {
          title
          metaDesc
          twitterTitle
          twitterDescription
          opengraphTitle
          opengraphDescription
        }
        slug
        investorLandingPage {
          video
          videoThumbnail {
            image {
              sourceUrl
              altText
            }
          }
          quickAccess {
            title
            list {
              url
              text
              icon {
                sourceUrl
                altText
              }
            }
          }
          investorRelations {
            title
            text
            image {
              sourceUrl
              altText
            }
            button {
              url
              text
            }
          }
          headline
          cover {
            title
            image {
              sourceUrl
              altText
            }
          }
        }
        translation(language: ID) {
          seo {
            title
            metaDesc
            twitterTitle
            twitterDescription
            opengraphTitle
            opengraphDescription
          }
          investorLandingPage {
          video
          videoThumbnail {
            image {
              sourceUrl
              altText
            }
          }
          quickAccess {
            title
            list {
              url
              text
              icon {
                sourceUrl
                altText
              }
            }
          }
          investorRelations {
            title
            text
            image {
              sourceUrl
              altText
            }
            button {
              url
              text
            }
          }
          headline
          cover {
            title
            image {
              sourceUrl
              altText
            }
          }
        }
        }
      }
      fileCategory(id: "annual", idType: NAME) {
        name
        pdfFiles {
          nodes {
            title
            pdfFiles {
              year
              file {
                link
                uri
                databaseId
                mediaItemUrl
              }
            }
          }
        }
      }
    }
  }
  
`